import React from "react";
import "./Product.css";
import productData from "../../Products/productData";
import ProductCard from "../../Products/ProductCard";
import { useNavigate } from "react-router-dom";

const Product = () => {
  const navigate = useNavigate();

  return (
    <section className="products-section1">
      <section className="section-title1">
        <h1>THE CHALO COLLECTION</h1>
        <p>WHERE INNOVATION MEETS LUXURY</p>

        <div className="divider1">
          <span></span>
          <div className="diamond1"></div>
          <span></span>
        </div>
      </section>

      <div className="products-grid1">
        {/* ✅ SHOW ONLY FIRST 5 PRODUCTS */}
        {productData.slice(0, 6).map((item) => (
          <ProductCard key={item.id} product={item} />
        ))}

        {/* ✅ MORE BIKES BUTTON */}
        <div className="more-bikes-wrapper">
          <button
            className="more-bikes-btn"
            onClick={() => navigate("/products")}
          >
            View More Bikes →
          </button>
        </div>
      </div>
    </section>
  );
};

export default Product;
